import React, { useState } from 'react';
import Grid from '@cloudscape-design/components/grid';
import ContentLayout from '@cloudscape-design/components/content-layout';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Spinner from '@cloudscape-design/components/spinner';
import TaskStatusSection from '../components/home/TaskStatusSection';
import DocumentsSection from '../components/home/DocumentsSection';
import PreferencesSection from '../components/home/PreferencesSection';
import AuditOverviewSection from 'src/components/home/AuditOverviewSection';
import WhatsNewSection from '../components/home/WhatsNewSection';
import { ExpandableSection } from '@cloudscape-design/components';
import { Calendar, momentLocalizer, CalendarProps } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useCalendar } from 'src/hooks/useCalendar';
import './HomePage.scss';

const localizer = momentLocalizer(moment);

const HomePage = () => {
  const { calendarEvent, eventStyleGetter, onNavigate, onSelectEvent, isLoading } =
    useCalendar();

  return (
    <ContentLayout data-testid="home-content-layout">
      <SpaceBetween size="l" data-testid="home-space-between">
        {/* Main Content Sections */}
        <Grid
          className="full-height"
          gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          data-testid="main-content-grid"
        >
          <AuditOverviewSection />
          <TaskStatusSection />
        </Grid>

        {/* What's New Section - always show if features exist */}
        <WhatsNewSection />

        <ExpandableSection
          defaultExpanded
          variant="container"
          headerText="Calendar"
          data-testid="calendar-expandable-section"
        >
          <div
            className={`calendar-container ${isLoading ? 'calendar-container--loading' : ''}`}
            data-testid="calendar-container"
            role="region"
            aria-label="Calendar view showing tasks and audits"
          >
            {isLoading && (
              <div
                className="calendar-loading-spinner"
                role="status"
                aria-live="polite"
                aria-label="Loading calendar data"
              >
                <Spinner size="large" />
              </div>
            )}
            {React.createElement(Calendar as any, {
              localizer,
              'events': calendarEvent,
              'startAccessor': 'start',
              'endAccessor': 'end',
              'eventPropGetter': eventStyleGetter,
              onNavigate,
              onSelectEvent,
              'popup': true,
              'data-testid': 'calendar',
              'aria-label': 'Task and audit calendar',
            })}
          </div>
        </ExpandableSection>

        {/* Bottom Section */}
        <Grid
          className="full-height"
          gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          data-testid="bottom-content-grid"
        >
          <DocumentsSection />
          <PreferencesSection />
        </Grid>
      </SpaceBetween>
    </ContentLayout>
  );
};

export default HomePage;
